<template>
    <div class="main_center">
      <div class="search-content">
        <div class="mainBtn">
          <el-button size="small" type="primary" @click="routerAdd">新增</el-button>
        </div>
        <div class="searchBtn">
          <el-button @click="getData" icon="el-icon-refresh" type="text"></el-button>
        </div>
      </div>
      <el-table
        v-loading="loading"
        :data="listData"
        border
        stripe
        :height="tableMaxHeight"
        class="table-content"
        align="center"
      >
        <el-table-column
          label="序号"
          width="50"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="tradeOrgName"
          label="交易中心"
          align="center"
        />
        <el-table-column
          prop="linkMan"
          label="场地联系人"
          align="center"
          show-overflow-tooltip
        />
        <el-table-column
          prop="linkPhone"
          label="联系方式"
          align="center"
        />
        <el-table-column
          label="操作"
          align="center"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="openDefend(scope.row)">维护</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div>
      <!-- <paginationCom  @sizechange="sizeChangeHandle" @pagechange="pageChangeHandle" class="limit" :options="paginationOpt"></paginationCom> -->
      </div>
    </div>
  </template>
  <script>
  import {removeTabHandle} from '@/utils/routeTab';
 
  export default {
    data() {
      return {
        loading: false,
        tableMaxHeight: document.documentElement.clientHeight - 237,
        listData: [],
        // listQuery: {
        //   page: 1,
        //   limit: 10
        // },
        // total: 0
        paginationOpt:{
            pageIndex:1,
            pageSize:10,
            total:0,
            pageSizes:[10,20,50]
          },
      }
    },
    activated() {
      this.listQuery = this.$options.data.call(this).listQuery
      this.getData()
    },
    mounted() {
      const that = this;
      let resizeTag = true;
      window.onresize = () => {
        if(resizeTag) { //防抖动
          that.ifmove();
          resizeTag = false
          setTimeout(() => {
            resizeTag = true
          }, 1000)
        }
      }
      that.ifmove();
    },
    methods: {
      ifmove() {
        // let hasBtnPermisson = this.hasBtnPermission('');
        let tableMaxHeight = document.documentElement.clientHeight - 237 ;
        this.paginationOpt.pageSize = parseInt((tableMaxHeight) / 50 ) || 1;
        this.$nextTick(() => {
          this.tableMaxHeight = tableMaxHeight
        })
      },
      // 获取列表数据
      getData() {
        this.loading = true
        const supperAdmin = this.$store.state.user.userinfo.supperAdmin;
        this.$http.post('/evalRoomManages/list',{
          page: this.paginationOpt.pageIndex,
          rows:this.paginationOpt.pageSize,
          filter: {
            tradeOrgId: supperAdmin ? '' : this.$store.state.user.userinfo.orgInfo.orgId
          }
        }, {baseURL:'/api'}).then(res => {
          this.loading = false
          if (res.data.code) {
            this.$message.error(res.data.msg)
            return
          }
          const { data } = res
          this.listData = data.rows || []
          this.paginationOpt.total = data.total || 0;
        })
      },
      sizeChangeHandle(value){// 每页长度改变待办事项
        this.paginationOpt.pageSize=value;
        this.paginationOpt.pageIndex=1;
        this.getData();
      },
      pageChangeHandle(value){ // 当前页改变待办事项
        this.paginationOpt.pageIndex = value;
        this.getData();
      },
      openDefend(row) {
        removeTabHandle('siteMaintenance-config')
        this.$router.push({
          path: '/fieldMaintain/index'
        })
        sessionStorage.setItem('row', JSON.stringify(row))
      },
      routerAdd(){
        removeTabHandle('siteMaintenance-config')
        sessionStorage.removeItem('row')
        this.$router.push({
          path: '/fieldMaintain/index'
        })
      }
    }
  }
  </script>
  <style lang="less" scoped>
  .info{
    margin-top:88px;
    padding:32px;
  }

  </style>
  